<template>
  <div class="wrapper">
    <div class="row" v-if="seminar">
      <div class="col-12">
        <div class="select-seminar form-section">
          <h3>{{ seminar.title }}</h3>
        </div>
      </div>
    </div>

    <div class="form-section">
      <div class="row">
        <v-input v-model="user.vorname" name="user.vorname" :label="$t('form.fields.first_name')" :required="true"></v-input>
        <v-input v-model="user.nachname" name="user.nachname" :label="$t('form.fields.last_name')" :required="true"></v-input>
      </div>

      <div class="row">
        <v-input columnclass="col-12" v-model="user.email" name="user.email" :label="$t('form.fields.email')" type="email" :required="true"></v-input>
      </div>
    </div>
    <!-- GDPR -->
    <br>
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="input-wrapper">
            <v-checkbox v-model="user.gdprnews" name="user.gdprnews" :label="$t('signupform.checkbox.newsletter')" :required="false"></v-checkbox>
          </div>
        </div>

        <div class="col-12">
          <div class="input-wrapper">
            <v-checkbox v-model="user.gdprdaten" name="user.gdprdaten" :label="$t('signupform.checkbox.gdpr', { link: gdprlink })" :required="true"></v-checkbox>
          </div>
        </div>

        <div class="col-12">
          <div class="input-wrapper">
            <v-checkbox v-model="user.agb" name="user.agb" :label="$t('signupform.checkbox.agb', { link: agblink })" :required="true"></v-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- Submit: -->
    <div class="row">
      <div class="col-lg-3 col-md-4 col-12">
        <div class="input-wrapper">
          <button @click.prevent="submit" :disabled="loading" class="btn-submit" style="display:flex">
            <span>{{ $t('ui.signup') }}</span>
            <span class="arrow"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import VInput from './fields/VInput'
import VCheckbox from './fields/VCheckbox'

const { mapState, mapActions } = createNamespacedHelpers('signupform')

export default {
  components: {
    VInput,
    VCheckbox
  },

  data () {
    return {
      loading: false,
      user: {
        vorname: '',
        nachname: '',
        email: '',
        gdprnews: false,
        gdprdaten: false,
        agb: false
      }
    }
  },

  created () {
    this.update(['seminar', null])
    this.fetchSeminar(
      { id: this.$route.params.event }
    )
  },

  computed: {
    ...mapState(['signupform', 'seminar']),
    gdprlink () {
      const name = this.$t('ui.gdpr')
      const link = this.$store.state.locale === 'en'
        ? '/en/privacy-policy/'
        : '/datenschutz/'
      return `<a href='${link}' target='_blank' rel='noopener'>${name}</a>`
    },
    agblink () {
      const name = this.$t('ui.agb')
      const link = this.$store.state.locale === 'en'
        ? '/en/business-and-cancellation-conditions/'
        : '/geschaefts-und-stornobedingungen/'
      return `<a href='${link}' target='_blank' rel='noopener'>${name}</a>`
    }
  },

  methods: {
    ...mapActions(['update', 'store', 'fetchSeminar']),
    async submit () {
      this.loading = true
      var response = await this.store()
      this.loading = false

      response.success && this.$router.push({ name: 'thankyou' })
    }
  },

  watch: {
    user: {
      deep: true,
      handler: function (val) {
        this.update(['user', val])
      }
    }
  }
}
</script>
